var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-12",attrs:{"fluid":""}},[_c('v-col',{attrs:{"cols":"auto pa-0 wrapper-container"}},[_c('SettingHeader',{attrs:{"header-text":_vm.$t('userManagement')}}),_c('user-team',{attrs:{"users":_vm.usersList,"team-name":_vm.teamName}})],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }